import classNames from 'classnames';
import SearchIcon from '@/shared/icons/flip-ui-kit/large/Search';

export const SearchInput = ({
  value,
  onChange,
  placeholder,
  className,
  placeholderClassName,
  disabled = false,
}: {
  value: string;
  onChange: (input: string) => void;
  placeholder?: string;
  className?: string;
  placeholderClassName?: string;
  disabled?: boolean;
}) => (
  <div className="relative w-full">
    <input
      disabled={disabled}
      className={classNames(
        'peer w-full rounded-md border border-cf-gray-4 bg-cf-gray-2 px-4 py-2.5 text-14 text-white outline-none transition hover:bg-cf-gray-3',
        'disabled:cursor-not-allowed disabled:bg-cf-gray-3 disabled:text-cf-gray-5',
        className,
      )}
      type="text"
      value={value}
      placeholder=""
      onChange={(e) => onChange(e.target.value)}
    />
    <div
      className={classNames(
        'pointer-events-none absolute left-4 top-[9px] flex items-center space-x-1.5 truncate whitespace-nowrap text-cf-light-1 opacity-0 transition peer-placeholder-shown:opacity-100 peer-focus-within:opacity-0 sm:top-[10px]',
        placeholderClassName,
      )}
    >
      <div>
        <SearchIcon />
      </div>
      <span className="pointer-events-none w-full truncate text-12  sm:text-14">{placeholder}</span>
    </div>
  </div>
);
